// ============================================================================
// PORTUGUESE TRANSLATIONS - CHAPTER 2: ÊXODO
// ============================================================================
// Níveis 14-26 (13 níveis, 39 perguntas)

export const chapter2Translations = {
  name: "Êxodo",
  description: "A libertação do povo de Deus... Conhecer Deus transforma nossas vidas",
  
  spiritualWisdom: {
    principle: "O conhecimento de Deus liberta e transforma",
    scripture: "Conhecereis a verdade, e a verdade vos libertará (João 8:32)",
    application: "Assim como Israel foi libertado do Egito, o conhecimento de Deus nos liberta da escravidão espiritual"
  },
  
  levels: {
    14: {
      name: "Moisés Salvo das Águas",
      challenge: "Uma mulher concebeu e deu à luz um filho. Viu que ele era formoso...",
      easy: {
        question: "Em que a mãe de Moisés o escondeu?",
        options: ["Uma caverna", "Um cesto de junco", "Um cesto", "Uma casa"],
        hint: "Este recipiente flutuava no Nilo",
        funFact: "🏺 O cesto de junco foi revestido com betume para ser impermeável!"
      },
      medium: {
        question: "Quem encontrou Moisés nos juncos?",
        options: [
          "A filha de Faraó",
          "Uma serva egípcia",
          "Sua irmã Miriã",
          "Um sacerdote egípcio"
        ],
        hint: "Um membro da família real egípcia",
        funFact: "👑 Ironicamente, é a família de Faraó que salva aquele que o desafiará!"
      },
      hard: {
        question: "Como a Providência divina usa até nossos inimigos?",
        options: [
          "Convertendo-os",
          "Orquestrando as circunstâncias para cumprir seus desígnios",
          "Punindo-os",
          "Ignorando-os"
        ],
        hint: "Trata-se de ver a mão de Deus nos eventos",
        funFact: "✨ Moisés cresceu no palácio daquele que oprimia seu povo!"
      }
    },
    
    15: {
      name: "A Sarça Ardente",
      challenge: "O anjo do Senhor lhe apareceu em uma chama de fogo...",
      easy: {
        question: "O que Moisés deveria tirar diante da sarça ardente?",
        options: ["Suas joias", "Suas sandálias", "Seu manto", "Seu turbante"],
        hint: "O que se usa nos pés",
        funFact: "👡 Tirar os sapatos expressa respeito em terra santa!"
      },
      medium: {
        question: "Que nome Deus revela a Moisés?",
        options: [
          "O Senhor",
          "EU SOU O QUE SOU",
          "O Todo-Poderoso",
          "O Criador"
        ],
        hint: "Um nome que expressa existência absoluta",
        funFact: "🔥 YHWH (Eu Sou) revela a essência eterna de Deus!"
      },
      hard: {
        question: "O que nos ensina a sarça que arde sem se consumir?",
        options: [
          "A magia existe",
          "Deus transcende as leis naturais",
          "O fogo é sagrado",
          "As plantas são mágicas"
        ],
        hint: "Trata-se da natureza divina que ultrapassa nossa compreensão",
        funFact: "🌿 A sarça simboliza que a presença divina santifica sem destruir!"
      }
    },

    16: {
      name: "As Dez Pragas do Egito",
      challenge: "Faraó endureceu seu coração e não os ouviu...",
      easy: {
        question: "Qual foi a primeira praga do Egito?",
        options: ["As rãs", "A água transformada em sangue", "As moscas", "Os piolhos"],
        hint: "Afetou o Nilo, fonte de vida para o Egito",
        funFact: "🩸 O Nilo era adorado como um deus, e Deus mostrou sua superioridade!"
      },
      medium: {
        question: "Qual foi a última e mais terrível das pragas?",
        options: [
          "O granizo",
          "As trevas",
          "A morte dos primogênitos",
          "Os gafanhotos"
        ],
        hint: "Esta praga afetou diretamente as famílias",
        funFact: "😢 Esta praga finalmente quebrou o orgulho de Faraó e libertou Israel!"
      },
      hard: {
        question: "Por que Deus endureceu o coração de Faraó?",
        options: [
          "Para puni-lo",
          "Para manifestar sua glória e seu poder",
          "Por maldade",
          "Para prolongar os sofrimentos"
        ],
        hint: "Trata-se de revelar quem é o verdadeiro Deus",
        funFact: "⚡ As pragas demonstram que YHWH é mais poderoso que todos os deuses egípcios!"
      }
    },

    17: {
      name: "A Páscoa",
      challenge: "Tomai um cordeiro... e poreis do seu sangue nos umbrais...",
      easy: {
        question: "Onde os israelitas deveriam colocar o sangue do cordeiro?",
        options: [
          "Em suas roupas",
          "Nos umbrais e nas ombreiras das portas",
          "Em suas testas",
          "Em taças"
        ],
        hint: "Na entrada de suas casas",
        funFact: "🩸 O sangue na porta era o sinal de proteção divina!"
      },
      medium: {
        question: "Como deveriam comer o cordeiro pascal?",
        options: [
          "Sentados confortavelmente",
          "Somente em família",
          "Com os lombos cingidos, sandálias nos pés, cajado na mão",
          "Em silêncio"
        ],
        hint: "Prontos para partir",
        funFact: "🚶 Eles deveriam estar prontos para partir rapidamente rumo à liberdade!"
      },
      hard: {
        question: "Como o Cordeiro pascal prefigura Cristo?",
        options: [
          "Por sua brancura",
          "Por seu sacrifício substitutivo que salva da morte",
          "Por sua mansidão",
          "Por sua idade"
        ],
        hint: "Trata-se do sacrifício que poupa da condenação",
        funFact: "🐑 Jesus é chamado de 'o Cordeiro de Deus que tira o pecado do mundo'!"
      }
    },

    18: {
      name: "A Travessia do Mar Vermelho",
      challenge: "Moisés estendeu sua mão sobre o mar...",
      easy: {
        question: "Como os israelitas atravessaram o mar?",
        options: [
          "De barco",
          "Nadando",
          "A pé enxuto",
          "De jangada"
        ],
        hint: "O fundo do mar ficou transitável",
        funFact: "🌊 Deus transformou um obstáculo em caminho de libertação!"
      },
      medium: {
        question: "O que aconteceu aos egípcios que perseguiam?",
        options: [
          "Voltaram atrás",
          "Foram engolidos pelas águas",
          "Se perderam",
          "Juntaram-se a Israel"
        ],
        hint: "As águas voltaram sobre eles",
        funFact: "⚔️ O exército mais poderoso do mundo foi destruído num instante!"
      },
      hard: {
        question: "O que simboliza esta travessia em nossa vida espiritual?",
        options: [
          "A fuga dos problemas",
          "A passagem da escravidão do pecado à liberdade em Deus",
          "A superioridade de Israel",
          "A destruição dos inimigos"
        ],
        hint: "Trata-se de uma transformação espiritual",
        funFact: "🗽 O Mar Vermelho representa o batismo: morte para o velho, vida nova!"
      }
    },

    19: {
      name: "O Maná no Deserto",
      challenge: "Que é isto? Pois não sabiam o que era...",
      easy: {
        question: "Por quanto tempo o maná caiu?",
        options: ["10 anos", "20 anos", "40 anos", "50 anos"],
        hint: "O mesmo número que os anos no deserto",
        funFact: "🍞 Durante 40 anos, Deus alimentou milagrosamente 2 milhões de pessoas!"
      },
      medium: {
        question: "O que acontecia se guardassem o maná por mais de um dia?",
        options: [
          "Ficava mais saboroso",
          "Se multiplicava",
          "Apodrecia e cheirava mal",
          "Endurecia"
        ],
        hint: "Exceto na sexta-feira para o sábado",
        funFact: "🪱 Deus assim ensinava a dependência diária dEle!"
      },
      hard: {
        question: "Como o maná nos ensina a confiança?",
        options: [
          "Estocando para o futuro",
          "Contando com a providência diária de Deus",
          "Trabalhando mais arduamente",
          "Compartilhando equitativamente"
        ],
        hint: "Trata-se de confiar dia após dia",
        funFact: "🙏 'O pão nosso de cada dia nos dai hoje' vem desta experiência!"
      }
    },

    20: {
      name: "A Água da Rocha",
      challenge: "Bate na rocha, e dela sairá água...",
      easy: {
        question: "Como Moisés deveria bater na rocha?",
        options: ["Com a mão", "Com o cajado", "Com o pé", "Com uma espada"],
        hint: "O instrumento que Deus lhe deu",
        funFact: "🪨 A simples obediência provocou um milagre sobrenatural!"
      },
      medium: {
        question: "Por que o povo tinha sede?",
        options: [
          "Por causa do calor",
          "Porque não havia água no deserto",
          "Por causa da longa jornada",
          "Por causa de doenças"
        ],
        hint: "Trata-se do ambiente deles",
        funFact: "💧 Deus criou uma fonte de água no deserto árido!"
      },
      hard: {
        question: "Como esta rocha prefigura Cristo?",
        options: [
          "Por sua força",
          "Sendo golpeada e dando água da vida",
          "Por seu tamanho",
          "Por sua localização"
        ],
        hint: "Trata-se da fonte de salvação",
        funFact: "⚡ Paulo disse: 'E a rocha era Cristo' (1 Coríntios 10:4)!"
      }
    },

    21: {
      name: "Os Dez Mandamentos",
      challenge: "Deus falou todas estas palavras, dizendo...",
      easy: {
        question: "Onde Deus deu os Dez Mandamentos?",
        options: ["No Egito", "No Monte Sinai", "Em Canaã", "No deserto"],
        hint: "A montanha sagrada com fogo e fumaça",
        funFact: "🔥 A presença de Deus fez tremer toda a montanha!"
      },
      medium: {
        question: "Em que foram gravados os Dez Mandamentos?",
        options: [
          "Em pergaminho",
          "Em tábuas de pedra pelo dedo de Deus",
          "Em madeira",
          "Em ouro"
        ],
        hint: "Um material permanente",
        funFact: "👆 O próprio Deus escreveu Sua lei!"
      },
      hard: {
        question: "Qual é o propósito da lei?",
        options: [
          "Salvar os homens",
          "Revelar o pecado e mostrar a natureza santa de Deus",
          "Punir os homens",
          "Escravizar os homens"
        ],
        hint: "Trata-se de revelar os padrões de Deus",
        funFact: "📜 A lei nos conduz à necessidade de Cristo!"
      }
    },

    22: {
      name: "O Bezerro de Ouro",
      challenge: "Tiraram suas joias e as trouxeram a Arão...",
      easy: {
        question: "O que o povo fez na ausência de Moisés?",
        options: [
          "Uma nova tenda",
          "Um bezerro de ouro",
          "Um monumento de ouro",
          "Um novo altar"
        ],
        hint: "Um objeto de idolatria",
        funFact: "🐄 Eles abandonaram o Deus da libertação para servir um ídolo!"
      },
      medium: {
        question: "Como Moisés reagiu a este pecado?",
        options: [
          "Ficou feliz",
          "Ficou furioso e quebrou as tábuas",
          "Fugiu",
          "Ignorou"
        ],
        hint: "Sua reação violenta",
        funFact: "😢 Quando a lei de Deus foi quebrada, Moisés quebrou a lei!"
      },
      hard: {
        question: "Por que o coração humano tende aos ídolos?",
        options: [
          "Por ignorância",
          "Desejo de confiar no visível e rebelião contra a soberania de Deus",
          "Por influência diabólica",
          "Por fraqueza"
        ],
        hint: "Trata-se da natureza humana e do desejo pelo visível",
        funFact: "💔 A idolatria substitui o Criador pela criatura!"
      }
    },

    23: {
      name: "O Tabernáculo",
      challenge: "Que eles me façam um santuário...",
      easy: {
        question: "O que era o Tabernáculo?",
        options: [
          "Um palácio",
          "Um santuário móvel de Deus",
          "Um armazém",
          "Uma escola"
        ],
        hint: "Um lugar para a presença de Deus",
        funFact: "⛺ Deus desejava habitar no meio do Seu povo!"
      },
      medium: {
        question: "Qual era o lugar mais sagrado do Tabernáculo?",
        options: [
          "O altar",
          "O Santo dos Santos",
          "A entrada",
          "A mesa dos pães"
        ],
        hint: "Onde estava a Arca da Aliança",
        funFact: "✨ Só o sumo sacerdote podia entrar ali uma vez por ano!"
      },
      hard: {
        question: "O que o Tabernáculo prefigurava?",
        options: [
          "O poder de Israel",
          "Emanuel, Deus conosco, cumprido por Cristo",
          "A importância dos sacerdotes",
          "A beleza dos rituais"
        ],
        hint: "Trata-se de Deus habitando entre os homens",
        funFact: "🙏 Jesus 'armou Sua tenda' entre nós (João 1:14)!"
      }
    },

    24: {
      name: "Os Espias de Canaã",
      challenge: "Envia homens para espiar a terra e o povo...",
      easy: {
        question: "Quantos espias foram enviados para espiar Canaã?",
        options: ["6", "10", "12", "24"],
        hint: "Um de cada tribo de Israel",
        funFact: "🕵️ 12 foram enviados, mas apenas 2 tinham fé!"
      },
      medium: {
        question: "Quem eram os dois espias com fé?",
        options: [
          "Moisés e Arão",
          "Josué e Calebe",
          "Arão e Miriã",
          "Gideão e Sansão"
        ],
        hint: "Os que sobreviveram para entrar em Canaã",
        funFact: "💪 Sua fé foi recompensada após 40 anos de peregrinação!"
      },
      hard: {
        question: "Qual foi a consequência da incredulidade?",
        options: [
          "Foram perdoados imediatamente",
          "Vagaram 40 anos no deserto",
          "Foram punidos imediatamente",
          "Foram exilados"
        ],
        hint: "Uma consequência longa",
        funFact: "😢 O medo custou a uma geração inteira a entrada na terra prometida!"
      }
    },

    25: {
      name: "A Serpente de Bronze",
      challenge: "Serpentes ardentes entraram no meio do povo e os morderam...",
      easy: {
        question: "Que tipo de serpentes morderam o povo?",
        options: ["Verdes", "Ardentes", "Gigantes", "Invisíveis"],
        hint: "Um adjetivo que descreve seu efeito mortal",
        funFact: "🐍 Estas serpentes simbolizavam as consequências mortais do pecado!"
      },
      medium: {
        question: "O que Deus ordenou a Moisés fazer para salvar o povo?",
        options: [
          "Fazer remédios",
          "Levantar uma serpente de bronze numa vara",
          "Orar",
          "Matar as serpentes"
        ],
        hint: "Um ato de fé",
        funFact: "⚕️ O simples ato de olhar salvava - simbolizando a fé!"
      },
      hard: {
        question: "Como Jesus citou este evento ao falar da cruz?",
        options: [
          "Sobre o perigo do pecado",
          "'Como Moisés levantou a serpente no deserto, assim deve ser levantado o Filho do Homem'",
          "Sobre a necessidade de obediência",
          "Sobre o poder da oração"
        ],
        hint: "Trata-se da salvação pela fé",
        funFact: "✝️ Jesus foi 'levantado' como a serpente de bronze para salvar pecadores!"
      }
    },

    26: {
      name: "A Terra Prometida",
      challenge: "Poderás vê-la com teus olhos, mas não entrarás nela...",
      easy: {
        question: "Quem conduziu Israel através do Jordão?",
        options: ["Moisés", "Arão", "Josué", "Calebe"],
        hint: "O sucessor de Moisés",
        funFact: "🚶 O nome de Josué tem o mesmo significado que Jesus: 'O Senhor salva'!"
      },
      medium: {
        question: "Por que Moisés não pôde entrar na terra prometida?",
        options: [
          "Estava muito velho",
          "Por sua desobediência nas águas de Meribá",
          "Recusou-se a conduzir o povo",
          "Estava doente"
        ],
        hint: "Um pecado específico anterior",
        funFact: "😢 Até Moisés enfrentou as consequências da desobediência!"
      },
      hard: {
        question: "O que a Terra Prometida simboliza?",
        options: [
          "Riqueza material",
          "O cumprimento das promessas de Deus em Cristo e nossa herança celestial",
          "As vitórias militares de Israel",
          "O fim do deserto"
        ],
        hint: "Trata-se do cumprimento espiritual das promessas de Deus",
        funFact: "🌿 Canaã aponta para a pátria celestial que nos espera!"
      }
    }
  }
};

export default chapter2Translations;
